import { z } from "zod"
import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/dashboard")({
	validateSearch: (search): { notesOrder?: string } => {
		const result = z.uuid().safeParse(search.notesOrder)
		return result.success ? { notesOrder: result.data } : {}
	},
	component: Outlet,
})
